export enum BonusPositionTypes {
    FreeGames,
    SpinMultiplier,
    RoundMultiplier,
    FlatBonus,
    CurrencyFlatBonus,
    Sticky,
    ExpandingSymbol,
    SymbolMultiplier,
    LevelBonus,
    SkillGame,
    SymbolMerge,
}